import { combineReducers } from 'redux';

import steps from './modules/steps/redux/steps-reducer';
import review from './modules/review/redux/review-reducer';

export default combineReducers({
  steps,
  review,
});
